import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=408d63b8&scoped=true"
import script from "./Project.vue?vue&type=script&setup=true&lang=js"
export * from "./Project.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Project.vue?vue&type=style&index=0&id=408d63b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d63b8",
  null
  
)

export default component.exports